import { useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Headphones } from "lucide-react";
import CustomerServiceModal from "./CustomerServiceModal";

/**
 * Green circular support button.
 * Scoped (per user request, Mar 7 2026) to the **login screen only** —
 * customers, drivers, mujahez, supervisors and admins no longer see the
 * floating bubble inside the app. Inside the app the support modal is
 * still reachable from the in-app dropdowns / call-admin entries.
 */
const SupportFloatingButton = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Render on the auth screens only.
  const allowedPaths = ["/login", "/signup", "/forgot-password",
                        "/driver-signup", "/mujahez-signup",
                        "/supervisor-signup"];
  if (!allowedPaths.includes(location.pathname)) return null;

  return (
    <>
      <motion.button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="global-support-btn"
        aria-label="مراسلة الإدارة"
        title="مراسلة الإدارة"
        animate={{
          boxShadow: [
            "0 0 0 0 rgba(37, 211, 102, 0.55)",
            "0 0 0 10px rgba(37, 211, 102, 0)",
            "0 0 0 0 rgba(37, 211, 102, 0)",
          ],
        }}
        transition={{ duration: 2.2, repeat: Infinity, ease: "easeOut" }}
        whileTap={{ scale: 0.92 }}
        whileHover={{ scale: 1.06 }}
        className="fixed top-2.5 right-2.5 z-[150] w-11 h-11 rounded-full bg-gradient-to-br from-[#25D366] to-[#1ebd5b] hover:from-[#1ebd5b] hover:to-[#16a34a] text-white flex items-center justify-center shadow-lg border border-white/30"
      >
        <Headphones className="w-5 h-5" strokeWidth={2.4} />
      </motion.button>

      <CustomerServiceModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default SupportFloatingButton;
